import React from "react";
import { CardActions } from "material-ui/Card";

export default class CustomCardActions extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { style = {}, disableSpacing = false } = this.props;
        return (
            <CardActions
                {...this.props}
                // this is used in material ui verion 4
                // disableSpacing={disableSpacing}
                style={Object.assign({}, style)}
            />
        );
    }
}
